var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,16.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75,0A9.75,9.75,0,1,0,19.5,9.75,9.75,9.75,0,0,0,9.75,0ZM9.68,18.14a8.39,8.39,0,1,1,8.39-8.39h0A8.38,8.38,0,0,1,9.7,18.14Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.68,13.72a1,1,0,1,1-2,0v-3h-3a1,1,0,0,1-.15-2H8.68v-3a1,1,0,0,1,2,0h0v3h3a1,1,0,0,1,0,2h-3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e9b2173ce0be6dff136f182e8322c947.svg";
export { ForwardRef as ReactComponent };